// eslint-disable-next-line import/prefer-default-export
export const COOKIES_NAME = 'tw_jwt_token';
